<ig-accordion *ngIf="settings" #accordion [mode]="mode" [title]="title" class="fav-event-filter"
  (onIconClicked)="clear()">
  <ng-container expand *ngIf="mode==='expand'">
    <ng-container *ngTemplateOutlet="favCustomBtns">
    </ng-container>
  </ng-container>

  <ng-container dropdown *ngIf="mode==='dropdown'">
    <ng-container *ngTemplateOutlet="favCustomBtns">
    </ng-container>
  </ng-container>

  <ng-template #favCustomBtns>
    <button mat-menu-item type="button" (click)="gotoCategory()" *ngIf="!hasFavoriteCategoryFromUrl"
      role="menuitemradio" [attr.aria-checked]="!title || title === 'FAVORITE LISTING'">ALL</button>
    <button *ngIf="!settings.customSettings.isHideEditorChoice&&!hasFavoriteCategoryFromUrl" mat-menu-item
      type="button"
      (click)="gotoEditorChoice(settings.customSettings.customEditorChoice.editorChoiceForPlace)"
      class="!flex flex-row-reverse !justify-end items-center choice-btn"
      [class.btn-selected]="title===settings.customSettings.customEditorChoice.editorChoiceForPlace"
      role="menuitemradio"
      [attr.aria-checked]="title===settings.customSettings.customEditorChoice.editorChoiceForPlace">
      {{settings.customSettings.customEditorChoice.editorChoiceForPlace}}
      <mat-icon class="ml-3 !text-red-400" aria-hidden="true">favorite</mat-icon>
    </button>
    <button mat-menu-item type="button" *ngFor="let btn of customPlaces" (click)="gotoCategory(btn)"
      [class.btn-selected]="title===btn.btnText"
      role="menuitemradio"
      [attr.aria-checked]="title===btn.btnText">
      {{btn.btnText}}
    </button>
  </ng-template>
</ig-accordion>
